import fetch from "@/helpers/fetch";
import params from "@/lib/params";

//获取各中心标签
export function getList(content) {
  return fetch.getFast("/api/tag/list", content);
}

//获取全部标签
export function getTagList(content) {
  return fetch.getFast("/tag/index/all", content);
}

//编辑
export function editTags(content) {
  return fetch.post("/api/tag/edit ", null, {
    body: params(content),
  });
}
